import React from 'react';
import Box from "@mui/material/Box";
import appContext from "../appContext";
import PublicRoutes from "./publicRoutes";
import PrivateRoutes from "./privateRoutes";
import CustomLoader from "../components/Custom/CustomLoader";

import { parseUrl } from "../Utils/common";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getInternalToken, getConfig, getUpdatedFormLink, testIntegration } from "../Services/API";

const RootRoutes = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [authUser, setAuthUser] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(true);
    const { setAuth, setProfileAvatar } = useContext(appContext)

    const getUserDetails = async (id: string): Promise<void> => {
        try {
            if (id) {
                const internalTokenRes = await getInternalToken(id);
                if (internalTokenRes?.data?.internalUUID) {
                    const configRes = await getConfig(internalTokenRes?.data?.internalUUID, id);
                    if (configRes?.data?.userId) {
                        setAuthUser(true);
                        setLoader(false);
                        sessionStorage.setItem("id", id);
                        sessionStorage.setItem("principalId", configRes?.data?.principalId);
                        if (configRes?.data?.data) {
                            const parsedData = JSON.parse(atob(configRes?.data?.data) || "")
                            const fullName: string = parsedData?.config?.name?.fullName ?? "";
                            const parsedName: string[] = fullName.split(" ");
                            (window as any)?.waymore?.reveal({
                                email: parsedData?.config?.email,
                                firstname: parsedName?.[0] ?? "",
                                lastname: parsedName?.length > 1 ? parsedName[1] : ""
                            });

                            setProfileAvatar(parsedData?.config?.avatar ?? "")
                            setAuth(parsedData?.config?.authToken ? parsedData?.config?.authToken : "")
                            sessionStorage.setItem("auth_token", parsedData?.config?.authToken);
                            if (parsedData?.config?.formUUID && parsedData?.config?.formData) {
                                navigate(`/editform?id=${parsedData?.config?.formUUID}`, { state: { formUUID: parsedData?.config?.formUUID, dataFromModal: JSON.parse(atob(parsedData?.config?.formData) || "") } })
                                sessionStorage.setItem('noWorkspace', 'true')
                            }
                            const scripts = document.querySelectorAll("script");

                            let routeeToken: string | null = null;

                            scripts.forEach(s => {
                                const content = s.innerHTML;
                                const match = content.match(/routeeToken\s*:\s*["'](.*?)["']/);

                                if (match) {
                                    routeeToken = match[1];
                                }
                            });

                            const domain = document.referrer;
                            if (domain != "") {
                                const testIntegrations = await testIntegration(routeeToken as any, domain);
                                if (testIntegrations?.status === 400 || testIntegrations?.data?.data?.snippetInstalled != true) {
                                    navigate('/mismatch')
                                    setAuthUser(false);
                                    setLoader(false);
                                    sessionStorage.clear();
                                }
                            }



                        }
                    } else {
                        setLoader(false);
                        sessionStorage.clear();
                        navigate('/notFound')
                    }
                } else if (sessionStorage.getItem('principalId') && sessionStorage.getItem('id') && sessionStorage.getItem('auth_token')) {
                    const updatedLink = await getUpdatedFormLink(sessionStorage.getItem('auth_token') || "")
                    if (updatedLink?.data?.url) {
                        const url = parseUrl(updatedLink?.data?.url)
                        window.location.replace(`?id=${url}`)
                        setLoader(false);
                    } else {
                        navigate('/notFound')
                        setLoader(false);
                        sessionStorage.clear();
                    }
                } else {
                    navigate('/notFound')
                    setLoader(false);
                    sessionStorage.clear();
                }
            } else {
                navigate('/notFound')
                setLoader(false);
                sessionStorage.clear();
            }
        } catch (error) {
            console.log("err", error)
            navigate('/notFound')
            setLoader(false);
            sessionStorage.clear();
        }
    }

    useEffect(() => {
        let id: string = searchParams.get("id") || "";
        if (id) {
            sessionStorage.setItem("id", id);
        } else {
            id = sessionStorage.getItem("id") || "";
        }
        getUserDetails(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (loader) {
        return (
            <Box component="div" height="100vh">
                <CustomLoader />
            </Box>
        );
    }

    return (
        <React.Fragment>
            {authUser ? <PrivateRoutes /> : <PublicRoutes />}
        </React.Fragment>
    );
}

export default RootRoutes